<template>
  <CBox v-if="variant === 'default'" cursor="pointer"
@click="$listeners.click">
    <CFlex w="100%" mb="24px">
      <CBox w="80%" mr="44px">
        <OmtTypography
          mb="4px"
          as="h3-semi-bold"
          :color="colorSecondary ? 'var(--colors-light-primary-navy-blue)' : undefined"
        >
          {{ formattedDescricaoPrestador }}
        </OmtTypography>

        <OmtTypography mb="4px" as="p2"
color="#8C8C8C">
          {{ especialidades }}
        </OmtTypography>

        <CFlex
          v-if="getNotaFormatada || getDistanciaFormatada || WhatsApp || Teleconsulta || Agendamento"
          align-items="center"
          flex-wrap="wrap"
          grid-gap="8px"
        >
          <CFlex v-if="getNotaFormatada" v-show="false"
align-items="center">
            <FontAwesomeIcon icon="fa-sharp fa-star" size="xl"
color="var(--colors-light-support-warning)" />
            <OmtTypography as="h3-semi-bold" ml="8px"
color="var(--colors-light-support-warning)">
              {{ getNotaFormatada }}
            </OmtTypography>
          </CFlex>

          <template v-if="getDistanciaFormatada">
            <CBox v-show="false" mx="12px" display="flex" align-items="center">
              <OmtTypography as="h3-semi-bold" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <OmtTypography as="h3-semi-bold">{{ getDistanciaFormatada }} km</OmtTypography>
            </CBox>
          </template>

          <template v-if="WhatsApp && !isAccreditedNetworkFlow">
            <CBox mx="12px" display="flex"
align-items="center">
              <OmtTypography as="h3-semi-bold" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <CBox as="button" bg="transparent"
p="0" minW="auto" h="auto" color="var(--colors-light-primary-gray1)">
                <FontAwesomeIcon icon="fa-brands fa-whatsapp" color="var(--colors-light-support-success)"
size="xl" />
              </CBox>
            </CBox>
          </template>

          <template v-if="Teleconsulta">
            <CBox mx="12px" display="flex"
align-items="center">
              <OmtTypography as="h3-semi-bold" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <FontAwesomeIcon icon="fa-light fa-video" size="lg" />
            </CBox>
          </template>
          <template v-if="Agendamento && !isAccreditedNetworkFlow">
            <CBox mx="12px" display="flex"
align-items="center">
              <OmtTypography as="h3-semi-bold" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <FontAwesomeIcon icon="fa-light fa-calendar" size="xl" />
            </CBox>
          </template>
        </CFlex>

        <OmtTypography as="p2">{{ formattedAddress }}</OmtTypography>
      </CBox>

      <CFlex align-items="center">
        <FontAwesomeIcon icon="fa-light fa-angle-right" size="lg" />
      </CFlex>
    </CFlex>
  </CBox>

  <CBox v-else-if="variant === 'primary'" cursor="pointer"
@click="$listeners.click">
    <CFlex bg="#FFFFFF" width="100%"
mb="16px" align-items="flex-start" p="16px" border-radius="8px">
      <CBox width="100%" mr="44px">
        <OmtTypography
          mb="4px"
          as="h3-semi-bold"
          :style="{ color: colorSecondary ? 'var(--colors-light-primary-navy-blue)' : undefined }"
        >
          {{ formattedDescricaoPrestador }}
        </OmtTypography>

        <OmtTypography mb="4px" as="p2"
color="#8C8C8C">
          {{ especialidades }}
        </OmtTypography>

        <OmtTypography mb="4px" as="p2">{{ formattedAddress }}</OmtTypography>

        <CFlex
          v-if="
            getNotaFormatada || getDistanciaFormatada || WhatsApp || Teleconsulta || Agendamento || Network || Favorito
          "
          align-items="center"
          flex-wrap="wrap"
          grid-gap="8px"
        >
          <CFlex v-if="getNotaFormatada" v-show="false"
align-items="center">
            <FontAwesomeIcon icon="fa-sharp fa-star" size="xl"
color="var(--colors-light-support-warning)" />
            <OmtTypography as="p2" ml="8px"
color="var(--colors-light-support-warning)">
              {{ getNotaFormatada }}
            </OmtTypography>
          </CFlex>

          <template v-if="getDistanciaFormatada || Network">
            <CBox display="inline-flex" align-items="center">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <template v-if="getDistanciaFormatada"> {{ getDistanciaFormatada }} km </template>
                <template v-if="getDistanciaFormatada && Network">
                  <b style="margin-left: 4px; margin-right: 4px">•</b>
                </template>
                <template v-if="Network">
                  {{ Network }}
                </template>
              </OmtTypography>
            </CBox>
          </template>

          <template v-if="WhatsApp && !isAccreditedNetworkFlow">
            <CBox mx="4px">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox
              as="button"
              bg="transparent"
              p="0"
              minW="auto"
              color="var(--colors-light-primary-gray1)"
              display="inline-flex"
              align-items="center"
            >
              <FontAwesomeIcon icon="fa-brands fa-whatsapp" color="var(--colors-light-support-success)"
size="xl" />
            </CBox>
          </template>

          <template v-if="Teleconsulta">
            <CBox mx="4px">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Telemedicina </OmtTypography>
            </CBox>
          </template>
          <template v-if="Agendamento && !isAccreditedNetworkFlow">
            <CBox mx="4px">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <FontAwesomeIcon icon="fa-light fa-calendar" size="xl" />
            </CBox>
          </template>

          <template v-if="Favorito">
            <CBox mx="4px">
              <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                <b>•</b>
              </OmtTypography>
            </CBox>

            <CBox display="inline-flex" align-items="center">
              <FontAwesomeIcon icon="fa-solid fa-heart" size="xs"
color="#1CA0FF" />
            </CBox>
          </template>
        </CFlex>

        <CFlex v-if="descricaoObservacao" class="affiliate-provider-observation">
          <OmtIcons class="affiliate-provider-observation__icon" name="circle-info" color="#0047A1" size="inherit" />
          <OmtTypography as="p2" class="affiliate-provider-observation__text">
            <strong>Observação:</strong> {{ descricaoObservacao }}
          </OmtTypography>
        </CFlex>
      </CBox>

      <CFlex align-items="center" align-self="center">
        <FontAwesomeIcon icon="fa-light fa-angle-right" size="lg" />
      </CFlex>
    </CFlex>
  </CBox>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    variant: {
      type: String,
      default: "default"
    },
    TipoLogradouro: String,
    EnderecoRua: String,
    EnderecoNumero: [String, Number],
    EnderecoComplemento: String,
    EnderecoBairro: String,
    EnderecoCidade: String,
    CodigoEstado: String,
    DescricaoPrestador: String,
    DescricaoEspecialidade: String,
    Distancia: Number,
    Network: String,
    DescricaoObservacao: [String, Number],
    Favorito: Boolean,
    CodigoPrestador: String,
    SrEndereco: String,
    DsIdioma: String,
    Nota: Number,
    WhatsApp: Boolean,
    Teleconsulta: Boolean,
    Agendamento: Boolean,
    colorSecondary: Boolean,
    isAccreditedNetworkFlow: Boolean
  },
  data() {
    return {
      favorite: this.Favorito
    };
  },
  computed: {
    getDistanciaFormatada() {
      return this.Distancia ? `${Math.round(this.Distancia * 100) / 100}`.replaceAll(".", ",") : "";
    },
    getNotaFormatada() {
      return this.Nota ? `${Math.round(this.Nota * 10) / 10}`.replaceAll(".", ",") : "";
    },
    formattedDescricaoPrestador() {
      if (!this.isAccreditedNetworkFlow) {
        return this.DescricaoPrestador;
      }
      return this.DescricaoPrestador.toLowerCase().replace(/(^|\s)\S/g, char => char.toUpperCase());
    },
    especialidades() {
      if (!this.DescricaoEspecialidade) return [];
      return this.DescricaoEspecialidade.replaceAll("|", " • ");
    },
    descricaoObservacao() {
      return String(this.DescricaoObservacao ?? "")
        .replace(/\s+/g, " ")
        .trim();
    },
    formattedAddress() {
      const logradouro = [this.TipoLogradouro, this.EnderecoRua].filter(Boolean).join(" ").trim();
      const numero =
        this.EnderecoNumero !== undefined && this.EnderecoNumero !== null ? `${this.EnderecoNumero}`.trim() : "";
      const complemento = this.EnderecoComplemento ? `${this.EnderecoComplemento}`.trim() : "";
      const cidadeUf = [this.EnderecoCidade, this.CodigoEstado]
        .filter(Boolean)
        .map(value => `${value}`.trim())
        .filter(Boolean)
        .join(" / ");
      const bairroCidadeUf = [this.EnderecoBairro, cidadeUf]
        .filter(Boolean)
        .map(value => `${value}`.trim())
        .filter(Boolean)
        .join(" - ");

      return [[logradouro, numero, complemento].filter(Boolean).join(", "), bairroCidadeUf].filter(Boolean).join(" - ");
    }
  }
};
</script>

<style scoped>
.affiliate-provider-observation {
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  padding: 5px 8px;
  border: 1px solid #cfe0ff;
  border-radius: 6px;
  background: #eef5ff;
}

.affiliate-provider-observation__icon {
  width: 14px;
  min-width: 14px;
  height: 14px;
  margin-top: 1px;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 14px;
}

.affiliate-provider-observation__text {
  margin: 0;
  color: #111827;
  font-size: 11px;
  line-height: 16px;
  word-break: break-word;
}
</style>
